import { Logger } from "@core/helpers/logger.helpers";
import { posthog } from "posthog-js";
import { AuthenticationManager } from "@core/managers/authentication.manager";
import { CandidateProfileService } from "@core/services";

export class PosthogManager {
  static async init() {
    try {
      const apiKey = process.env.VUE_APP_POSTHOG_API_KEY;
      const apiHost = process.env.VUE_APP_POSTHOG_API_HOST;

      posthog.init(apiKey, {
        api_host: apiHost,
        capture_pageview: false,
        autocapture: false,
      });
    } catch (error) {
      Logger.info(`[Posthog::Manager] ${error}`);
    }
  }
  static async reloadFeatureFlags() {
    try {
      await posthog.reloadFeatureFlags();
      Logger.info("[Posthog::Manager] Feature flags successfully reloaded");
    } catch (error) {
      Logger.info(`[Posthog::Manager] Error reloading feature flags: ${error}`);
      throw error;
    }
  }
  static async setUserIdentify() {
    try {
      const isAuthenticated = await AuthenticationManager.isUserAuthenticated();

      if (!isAuthenticated) {
        return;
      }

      // Define profile info of the user
      const candidate = await CandidateProfileService.getProfile();
      posthog.identify(candidate.email, {
        email: candidate.email,
        is_logged_in: isAuthenticated,
      });
    } catch (error) {
      Logger.info(`[Posthog::Manager] ${error}`);
    }
  }
  static async captureEvent(eventName, eventProperties) {
    try {
      posthog.capture(eventName, eventProperties);
    } catch (error) {
      Logger.info(`[Posthog::Manager] ${error}`);
    }
  }
  static isFeatureEnabled(featureFlag) {
    try {
      if (!posthog) {
        Logger.warn(`[Posthog::Manager] PostHog not initialized`);
        return false;
      }
      return posthog.isFeatureEnabled(featureFlag);
    } catch (error) {
      Logger.error(`[Posthog::Manager] Error checking feature flag: ${error}`);
      return false;
    }
  }
  static isVersionA(featureFlag) {
    try {
      if (!posthog) {
        Logger.warn(`[Posthog::Manager] PostHog not initialized`);
        return false;
      }
      return posthog.getFeatureFlag(featureFlag) === "control";
    } catch (error) {
      Logger.error(`[Posthog::Manager] Error checking feature flag: ${error}`);
      return false;
    }
  }
}
